import { IChatViewState } from './types';

export const getChatViewInitialState = (): IChatViewState => ({
    groups: null,
    chats: {},
    openedGroupId: null,
    openedChatId: null,
});
